module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p1.13e007b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p1.png
// module id = Q3rm
// module chunks = 10